/**
 * Заявки: валідація, відправка і модалка.
 *
 * Обробляє КОЖНУ форму .lead-form на сторінці — і секцію «Форма заявки», і ту,
 * що всередині модалки. Раніше скрипт блока шукав елемент за id (#leadForm),
 * тож друга форма на сторінці просто не працювала б.
 *
 * Відправка йде на той самий admin-ajax action `phpdev_lead`, що й до появи
 * модалки: лист на пошту студії + копія в Telegram (incs/theme/lead-form.php).
 */
(function () {
  var OK_MS = 10000;   // скільки живе панель «дякуємо» — синхронно з анімацією .lead-ok-bar

  // Маски телефону тут свідомо немає: будь-який автоформат під +380 збиває з
  // пантелику клієнта з польським чи американським номером — він бачить, як
  // поле переписує введене. Формат перевіряє лише валідація: 9+ цифр.

  /* ---------- валідація ---------- */
  function digits(v) { return (v.match(/\d/g) || []).length; }

  function check(el) {
    var ok = true;
    var v = el.value.trim();
    if (el.name === 'name') ok = v.length >= 2;
    if (el.name === 'phone') ok = digits(v) >= 9;
    if (el.name === 'email') ok = !v || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
    el.closest('.field').classList.toggle('err', !ok);
    el.setAttribute('aria-invalid', String(!ok));
    return ok;
  }

  function initForm(form) {
    if (form.dataset.leadReady) return;
    form.dataset.leadReady = '1';

    var slot = form.closest('.lead-slot');
    var okBox = slot ? slot.querySelector('.lead-ok') : null;
    var msg = form.querySelector('.form-msg');
    var btn = form.querySelector('button[type="submit"]');
    var d = form.dataset;
    var timer = null;

    // Тільки видимі поля: у розмітці є ще nonce, назва сторінки, джерело й
    // honeypot — вони лежать поза .field, і check() спіткнувся б на closest().
    var inputs = form.querySelectorAll('.field input[name]');

    inputs.forEach(function (el) {
      el.addEventListener('blur', function () { if (el.value) check(el); });
      el.addEventListener('input', function () {
        if (el.closest('.field').classList.contains('err')) check(el);
      });
    });

    var dialog = form.closest('dialog');

    function restore() {
      if (timer) { clearTimeout(timer); timer = null; }
      if (okBox) { okBox.hidden = true; okBox.classList.remove('is-on'); }
      if (dialog) dialog.classList.remove('is-ok');
      form.hidden = false;
      if (msg) { msg.textContent = ''; msg.classList.remove('bad'); }
    }
    form.leadRestore = restore;

    function showOk() {
      // Для аналітики (global-scripts.js → GA4 generate_lead): заявка справді пішла.
      document.dispatchEvent(new CustomEvent('phpdev:lead', {detail: {place: dialog ? 'modal' : 'page'}}));
      form.reset();
      form.querySelectorAll('.field.err').forEach(function (f) { f.classList.remove('err'); });
      if (!okBox) { if (msg) msg.textContent = d.success || ''; return; }
      form.hidden = true;
      okBox.hidden = false;
      if (dialog) dialog.classList.add('is-ok');
      // Клас вмикає анімацію смужки — саме тут, а не в розмітці, інакше вона
      // відпрацювала б один раз при завантаженні сторінки.
      requestAnimationFrame(function () { okBox.classList.add('is-on'); });
      timer = setTimeout(function () {
        if (dialog && dialog.open) { dialog.close(); return; }   // у модалці — просто закриваємось
        restore();
      }, OK_MS);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var valid = true;
      inputs.forEach(function (el) { if (!check(el)) valid = false; });
      if (!valid) {
        if (msg) { msg.textContent = d.msgInvalid || ''; msg.classList.add('bad'); }
        var bad = form.querySelector('.field.err input');
        if (bad) bad.focus();
        return;
      }

      if (msg) { msg.textContent = d.msgSending || ''; msg.classList.remove('bad'); }
      if (btn) btn.disabled = true;

      var body = new FormData(form);
      body.append('action', 'phpdev_lead');

      fetch(d.ajax, { method: 'POST', body: body, credentials: 'same-origin' })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function (res) {
          if (res && res.success) {
            showOk();
          } else {
            if (msg) {
              msg.textContent = (res && res.data && res.data.message) || d.msgError || '';
              msg.classList.add('bad');
            }
          }
        })
        .catch(function () {
          if (msg) { msg.textContent = d.msgError || ''; msg.classList.add('bad'); }
        })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  /* ---------- модалка ---------- */
  function initModal() {
    var dlg = document.querySelector('.lead-modal');
    if (!dlg || typeof dlg.showModal !== 'function') return;   // без <dialog> лишається якір на секцію

    var form = dlg.querySelector('.lead-form');
    var opener = null;

    function open(from) {
      opener = from || null;
      if (form && form.leadRestore) form.leadRestore();
      // Джерело: підпис кнопки їде в лист — «Замовити плагін» і «Замовити
      // інтеграцію» це різні заявки, а сторінка в обох випадках одна.
      // data-lead-source перекриває підпис: у блоці цін усі кнопки звуться
      // «Обрати», і без атрибута з листа не було б видно, який пакет узяли.
      var src = form && form.querySelector('input[name="source"]');
      if (src) src.value = from ? (from.getAttribute('data-lead-source') || from.textContent || '').trim() : '';
      dlg.showModal();
      document.body.classList.add('locked');
      var first = dlg.querySelector('input[name="name"]');
      if (first) first.focus({ preventScroll: true });
    }

    dlg.addEventListener('close', function () {
      document.body.classList.remove('locked');
      if (form && form.leadRestore) form.leadRestore();
      if (opener && document.contains(opener)) opener.focus();
      opener = null;
    });

    // Клік по підкладці — теж закриття: сам <dialog> займає лише вікно,
    // тому клік «повз» приходить саме на нього.
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) dlg.close();
    });

    dlg.querySelectorAll('[data-close]').forEach(function (b) {
      b.addEventListener('click', function () { dlg.close(); });
    });

    // Кнопки заявки по всьому сайту ведуть на #cta або #lead. Перехоплюємо їх,
    // щоб не правити URL у кожній кнопці в адмінці.
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="#cta"],a[href="#lead"],[data-lead-open]');
      if (!a) return;
      e.preventDefault();
      open(a);
    });
  }

  function init() {
    document.querySelectorAll('.lead-form').forEach(initForm);
    initModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
